/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-const */
/* eslint-disable consistent-return  */
export default {
  _init() {
    if (!this.options.Vue.axios) {
      return 'axios.js : Vue.axios must be set.';
    }
  },

  _interceptor(req, res) {
    let _this = this;

    if (req) {
      this.options.Vue.axios.interceptors.request.use((request) => {
        req.call(_this, request);
        return request;
      }, (error) => {
        req.call(_this, error.request);
        return Promise.reject(error);
      });
    }

    if (res) {
      this.options.Vue.axios.interceptors.response.use((response) => {
        res.call(_this, response);
        return response;
      }, (error) => {
        if (error && error.response) {
          res.call(_this, error.response);
        }
        return Promise.reject(error);
      });
    }
  },

  _invalidToken(res) {
    // if (res.status === 401) {
    //   this.logout();
    // }
    if (res.status === 401) {
      return true;
    }
  },

  _httpData(res) {
    return res.data || {};
  },

  _http(data) {
    this.options.Vue.axios(data).then((success) => {
      data.success(success);
    }, (error) => {
      console.log('_http', error);
      const response = error.response || error;
      data.error(response);
    });
  },

  _getHeaders(res) {
    return res.headers;
  },

  _setHeaders(req, headers) {
    req.headers.common = Object.assign(req.headers.common, headers);
  },
};



// WEBPACK FOOTER //
// ./src/middleware/http/axios.js